import { Text, View } from '@react-pdf/renderer';
import { FC } from 'react';
import styles from '../styles';

export const PdfTitle: FC<any> = () => (
  <View style={styles.title}>
    <Text>RIEPILOGO DATI OFFERTA</Text>
  </View>
);
